import { Layers, Database, Cpu, GitBranch, ShieldAlert, Gauge } from "lucide-react";
import ProductPageLayout from "@/components/ProductPageLayout";

export default function Technology() {
  return (
    <ProductPageLayout
      meta={{
        title: "Technology — Market Analytics & Quantitative Research Infrastructure | Adviserz",
        description:
          "The Adviserz technology stack: market data infrastructure, quantitative research engines, machine learning pipelines and analytics delivery. A brand of Quant Core Technologies Private Limited.",
        canonical: "https://adviserz.in/technology",
      }}
      overline="Platform · Technology"
      title="Financial technology built for"
      accent="analytical depth."
      lede="Adviserz is a financial technology platform focused on research, analytics and market intelligence. Our stack ingests market and derivatives data, structures it through quantitative research pipelines, and presents analytical outputs designed to help market participants understand market behaviour with greater depth."
      capabilities={[
        { icon: Database, t: "Market Data Infrastructure", d: "Ingestion, normalisation and storage of equity and derivatives market data, including time-series, options chain structure and open interest datasets." },
        { icon: Cpu, t: "Quantitative Research Engine", d: "Statistical analysis, time-series modelling, feature engineering and backtesting infrastructure used to study historical market behaviour." },
        { icon: Layers, t: "Analytics & Visualisation Layer", d: "Market data visualisation, market-structure analysis and scenario views designed for clarity rather than prescription." },
        { icon: GitBranch, t: "News Intelligence Pipeline", d: "AI-assisted aggregation, classification, entity extraction and summarisation of financial news and market events." },
        { icon: ShieldAlert, t: "Risk Analytics", d: "Volatility analytics, exposure analytics and probability & scenario analysis to help users frame risk in quantitative terms." },
        { icon: Gauge, t: "Engineering & Reliability", d: "Cloud infrastructure, observability, data-quality checks and versioned model deployment across the analytics stack." },
      ]}
      approach={[
        { t: "Data acquisition", d: "Market, derivatives and news data is collected from data providers and public sources, then normalised into consistent internal schemas." },
        { t: "Feature engineering", d: "Raw data is transformed into quantitative features — volatility measures, market-structure descriptors, positioning statistics and event markers." },
        { t: "Modelling & analysis", d: "Statistical and machine learning models are used to study relationships, patterns and regimes within historical and current market data." },
        { t: "Analytical output", d: "Results are presented as analytics, visualisations and contextual intelligence — clearly labelled as informational, not advisory." },
      ]}
      notWhatWeDo={[
        "No buy, sell or hold recommendations",
        "No personalised investment advice",
        "No portfolio management services",
        "No profit, return or accuracy guarantees",
        "No trading tips, calls or signals for purchase",
        "No execution or brokerage services",
      ]}
    />
  );
}
